import styled from "styled-components";

export const Actions = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    bottom: 16px;
    width: 100%;
    max-width: 320px;
    z-index: 10;
    padding: 0 24px;
    margin: 0 auto;
    left: auto;

    &.actions-customer {
        max-width: 450px;
    }

    @media (max-width: 600px) {
        padding: 0 16px;
    }
`;


export const MuteAction = (props: any) => {
    return (
        <Action className={`${props?.active ? 'active' : ''} ${!props?.available ? "unavailable" : ""}`}
                onClick={props?.available ? props?.onClick : undefined}>
            <ActionIcon>
                {!props?.active ? <MuteIcon/> : <MuteOffIcon/>}
            </ActionIcon>
            <ActionLabel>{props?.active ? props.labelOff : props?.label}</ActionLabel>
        </Action>
    );
}

export const FlipAction = (props: any) => {
    return (
        <Action className={`${props?.active ? 'active' : ''} ${!props?.available ? "unavailable" : ""}`}
                onClick={props?.available ? props?.onClick : undefined}>
            <ActionIcon>
                <FlipIcon/>
            </ActionIcon>
            <ActionLabel>{props?.active ? props?.label : props.labelOff}</ActionLabel>
        </Action>
    );
}

export const HangupAction = (props: any) => {
    return (
        <Action className={`${props?.active ? 'active' : ''} ${!props?.available ? "unavailable" : ""}`}
                onClick={props?.available ? props?.onClick : undefined}>
            <ActionIcon style={{backgroundColor: "#F8000F", borderRadius: 9}}>
                <HangupIcon/>
            </ActionIcon>
            <ActionLabel>{props?.active ? props?.label : props.labelOff}</ActionLabel>
        </Action>
    );
}

export const CameraAction = (props: any) => {
    return (
        <Action className={`${props?.active ? 'active' : ''} ${!props?.available ? "unavailable" : ""}`}
                onClick={props?.available ? props?.onClick : undefined}>
            <ActionIcon>
                {props?.active ? <CameraIcon/> : <CameraOffIcon/>}
            </ActionIcon>
            <ActionLabel>{props?.active ? props?.label : props.labelOff}</ActionLabel>
        </Action>
    );
}

export const SpeakerAction = (props: any) => {
    return (
        <Action className={`${props?.active ? 'active' : ''} ${!props?.available ? "unavailable" : ""}`}
                onClick={props?.available ? props?.onClick : undefined}>
            <ActionIcon>
                {props?.active ? <SpeakerIcon/> : <SpeakerOffIcon/>}
            </ActionIcon>
            <ActionLabel>{props?.active ? props?.label : props.labelOff}</ActionLabel>
        </Action>
    );
}


const Action = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #fff;
    flex: 1;
    overflow: hidden;
    width: 100%;

    &.active {
    }

    &.unavailable {
        cursor: not-allowed;

        svg {
            opacity: 0.7;
        }
    }
`;

const ActionIcon = styled.div`
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 90px;
    background: rgba(0, 0, 0, 0.52);
    backdrop-filter: blur(15px);
    margin-bottom: 6px;

    svg {
        width: 22px;
        height: 22px;
        fill: currentColor;
    }
`;

const ActionLabel = styled.div`
    color: #FFF;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    width: 100%;

    @media (max-width: 600px) {
        font-size: 12px;
    }
`;

const MuteOffIcon = (props: any) => (
    <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.6836 11.8047V4.42188C13.6836 2.24219 12.2539 0.601562 10.1328 0.601562C8.03516 0.601562 6.58203 2.20703 6.58203 4.32812V4.69141L13.6836 11.8047ZM20.0938 21.9766C20.375 22.2578 20.8203 22.2578 21.0898 21.9766C21.3711 21.7188 21.3594 21.2617 21.0898 20.9922L1.89453 1.80859C1.63672 1.53906 1.16797 1.53906 0.898438 1.80859C0.628906 2.07812 0.628906 2.53516 0.898438 2.80469L20.0938 21.9766ZM4.74219 23.4648C4.36719 23.4648 4.05078 23.793 4.05078 24.1562C4.05078 24.5195 4.36719 24.8359 4.74219 24.8359H15.5234C15.8867 24.8359 16.2031 24.5195 16.2031 24.1562C16.2031 23.793 15.8867 23.4648 15.5234 23.4648H10.8125V20.3828C12.5234 20.2656 13.9883 19.6914 15.1133 18.7773L14.1406 17.8047C13.1094 18.6367 11.7383 19.1172 10.1328 19.1172C6.28906 19.1172 3.67578 16.4336 3.67578 12.7773V10.2578C3.67578 9.83594 3.40625 9.56641 3.00781 9.56641C2.60938 9.56641 2.33984 9.83594 2.33984 10.2578V12.7773C2.33984 16.9961 5.15234 20.0898 9.44141 20.3828V23.4648H4.74219ZM17.9141 10.2578C17.9141 9.83594 17.6445 9.56641 17.2461 9.56641C16.8477 9.56641 16.5781 9.83594 16.5781 10.2578V12.7773C16.5781 13.375 16.4961 13.9492 16.3555 14.4766L17.457 15.5781C17.75 14.7227 17.9141 13.7852 17.9141 12.7773V10.2578ZM12.0781 15.7422L6.58203 10.2344V12.6016C6.58203 14.7812 8.01172 16.4102 10.1328 16.4102C10.9062 16.4102 11.5742 16.1641 12.0781 15.7422Z" fill="white"/>
    </svg>
);

const MuteIcon = (props: any) => (
    <svg width="17" height="25" viewBox="0 0 17 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.9336 11.8047V4.42188C11.9336 2.24219 10.5039 0.601562 8.38281 0.601562C6.28516 0.601562 4.83203 2.20703 4.83203 4.32812V11.8047H11.9336ZM2.99219 23.4648C2.61719 23.4648 2.30078 23.793 2.30078 24.1562C2.30078 24.5195 2.61719 24.8359 2.99219 24.8359H13.7734C14.1367 24.8359 14.4531 24.5195 14.4531 24.1562C14.4531 23.793 14.1367 23.4648 13.7734 23.4648H9.0625V20.3828C10.7734 20.2656 12.2383 19.6914 13.3633 18.7773L12.25 18C11.2188 18.832 9.98828 19.1172 8.38281 19.1172C4.53906 19.1172 1.92578 16.4336 1.92578 12.7773V10.2578C1.92578 9.83594 1.65625 9.56641 1.25781 9.56641C0.859375 9.56641 0.589844 9.83594 0.589844 10.2578V12.7773C0.589844 16.9961 3.40234 20.0898 7.69141 20.3828V23.4648H2.99219ZM16.1641 10.2578C16.1641 9.83594 15.8945 9.56641 15.4961 9.56641C15.0977 9.56641 14.8281 9.83594 14.8281 10.2578V12.7773C14.8281 13.375 14.7461 13.9492 14.6055 14.4766L15.707 15.5781C16 14.7227 16.1641 13.7852 16.1641 12.7773V10.2578ZM10.3281 15.7422L4.83203 10.2344V12.6016C4.83203 14.7812 6.26172 16.4102 8.38281 16.4102C9.15625 16.4102 9.82422 16.1641 10.3281 15.7422Z" fill="white"/>
        <path d="M15.4961 9.56641C15.8945 9.56641 16.1641 9.83594 16.1641 10.2578V12.7773C16.1641 16.9961 13.3516 20.0898 9.0625 20.3828V23.4648H13.7617C14.1367 23.4648 14.4531 23.793 14.4531 24.1562C14.4531 24.5195 14.1367 24.8359 13.7617 24.8359H2.98047C2.61719 24.8359 2.30078 24.5195 2.30078 24.1562C2.30078 23.793 2.61719 23.4648 2.98047 23.4648H7.69141V20.3828C5.98047 20.2656 4.51562 19.6914 3.39062 18.7773L4.25 18C5.28125 18.832 6.76562 19.1172 8.37109 19.1172C12.2148 19.1172 14.8281 16.4336 14.8281 12.7773V10.2578C14.8281 9.83594 15.0977 9.56641 15.4961 9.56641Z" fill="white"/>
        <path d="M8.37109 0.601562C10.4688 0.601562 11.9219 2.20703 11.9219 4.32812V5.2373H11.9316V12.7139C11.9316 14.8349 10.4784 16.4404 8.38086 16.4404C6.25977 16.4404 4.83008 14.7998 4.83008 12.6201V11.8047H4.82031V4.42188C4.82031 2.24219 6.25 0.601562 8.37109 0.601562Z" fill="white"/>
        <path d="M1.25781 9.56641C1.65625 9.56641 1.92578 9.83594 1.92578 10.2578V12.7773C1.92578 13.375 2.00781 13.9492 2.14844 14.4766L1.04688 15.5781C0.753906 14.7227 0.589844 13.7852 0.589844 12.7773V10.2578C0.589844 9.83594 0.859375 9.56641 1.25781 9.56641Z" fill="white"/>
    </svg>
);

const FlipIcon = (props: any) => (
    <svg width="29" height="23" viewBox="0 0 29 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.25781 22.168H24.7305C27.0156 22.168 28.1875 20.9961 28.1875 18.7461V6.44141C28.1875 4.17969 27.0156 3.00781 24.7305 3.00781H21.7539C20.8164 3.00781 20.5469 2.87891 19.9844 2.24609L19.0117 1.15625C18.4023 0.5 17.8633 0.207031 16.6914 0.207031H12.1211C10.9609 0.207031 10.4102 0.5 9.8125 1.15625L8.82812 2.24609C8.27734 2.86719 7.99609 3.00781 7.05859 3.00781H4.25781C1.97266 3.00781 0.800781 4.17969 0.800781 6.44141V18.7461C0.800781 20.9961 1.97266 22.168 4.25781 22.168ZM22.0703 12.5C22.5039 12.5 22.668 12.9688 22.3867 13.3438L20.3828 16.0039C20.1484 16.2969 19.6914 16.3086 19.4453 16.0039L17.4414 13.3438C17.1602 12.9805 17.3359 12.5 17.7578 12.5H19.3164C19.3164 9.61719 17.2891 7.49609 14.582 7.49609C13.668 7.49609 12.8711 7.74219 12.1797 8.15234C11.5703 8.46875 11.0898 8.10547 11.0898 7.67188C11.0898 7.44922 11.1836 7.21484 11.4531 7.05078C12.2031 6.54688 13.3516 6.18359 14.582 6.18359C18.0156 6.18359 20.6406 8.84375 20.6406 12.5H22.0703ZM16.8086 16.3438C17.4297 16.0156 17.8984 16.4023 17.8984 16.8594C17.8984 17.0586 17.793 17.2695 17.5352 17.4453C16.7969 17.9609 15.6484 18.3008 14.4062 18.3008C10.9727 18.3008 8.35938 15.6406 8.35938 11.9844H6.91797C6.48438 11.9844 6.32031 11.5273 6.60156 11.1523L8.61719 8.49219C8.85156 8.19922 9.29688 8.17578 9.54297 8.49219L11.5586 11.1523C11.8281 11.5039 11.6641 11.9844 11.2305 11.9844H9.67188C9.67188 14.8672 11.6992 17 14.4062 17C15.332 17 16.1172 16.7539 16.8086 16.3438Z"
            fill="white"/>
    </svg>
);

const HangupIcon = (props: any) => (
    <svg width="27" height="12" viewBox="0 0 27 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M26.1304 8.09902L25.8442 9.4149C25.5752 10.6485 24.3948 11.4509 23.0863 11.2901L20.4801 10.9692C19.3455 10.829 18.3969 9.99493 18.1353 8.90786L17.4085 5.87979C16.228 5.35923 14.9189 5.10174 13.4819 5.10629C12.0981 5.0995 10.7271 5.37043 9.44986 5.90306L8.87787 8.70577C8.66037 9.76675 7.75837 10.5399 6.64149 10.6219L4.03794 10.816C2.7381 10.912 1.51791 10.0548 1.18188 8.81049L0.821265 7.47767C0.462989 6.15034 0.849576 4.77265 1.83721 3.8631C4.16882 1.71291 7.98654 0.705667 13.2928 0.837235C18.6069 0.969281 22.4874 2.17316 24.9295 4.44752C25.9573 5.40433 26.4149 6.79317 26.1304 8.09902Z"
            fill="white"/>
    </svg>
);

const CameraOffIcon = (props: any) => (
    <svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.9803 21.8126C21.2355 22.0678 21.6396 22.0571 21.8842 21.8126C22.1288 21.568 22.1288 21.1639 21.8842 20.9193L1.13766 0.183433C0.903717 -0.0611443 0.489 -0.0611443 0.233789 0.183433C-0.000154734 0.42801 -0.0107885 0.832094 0.233789 1.07667L20.9803 21.8126ZM16.6098 2.39526H4.97646L19.6511 17.0593C19.8531 16.6977 19.9701 16.1341 19.9701 15.5386V5.78744C19.9701 3.61815 18.7791 2.39526 16.6098 2.39526ZM20.9909 13.9861L25.0424 17.357C25.4146 17.6654 25.8081 17.8674 26.2015 17.8674C26.9459 17.8674 27.4457 17.3251 27.4457 16.4957V5.48969C27.4457 4.66026 26.9459 4.11793 26.2015 4.11793C25.8081 4.11793 25.4146 4.31998 25.0424 4.62836L20.9909 7.98863V13.9861ZM4.94456 19.5901H17.1628L1.82886 4.26681C1.62681 4.62836 1.50984 5.19195 1.50984 5.78744V16.1979C1.50984 18.3672 2.76463 19.5901 4.94456 19.5901Z" fill="white"/>
    </svg>
)

const CameraIcon = (props: any) => (
    <svg width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.7002 0.200195C17.357 0.200294 18.7002 1.5434 18.7002 3.2002V3.33789C18.7122 3.4828 18.7197 3.63248 18.7197 3.78711V13.5391C18.7197 13.6786 18.7126 13.8163 18.7002 13.9502V14.7002C18.7001 16.3569 17.3569 17.7001 15.7002 17.7002H3.2002C1.5434 17.7002 0.200294 16.357 0.200195 14.7002V3.2002C0.200195 1.54334 1.54334 0.200195 3.2002 0.200195H15.7002Z" fill="white"/>
        <path d="M24.9512 2.11816C25.6954 2.11816 26.1951 2.66007 26.1953 3.48926V14.4961C26.1951 15.3253 25.6954 15.8672 24.9512 15.8672C24.5578 15.8671 24.1641 15.6657 23.792 15.3574L19.7412 11.9863V5.98828L23.792 2.62793C24.1641 2.31963 24.5578 2.11827 24.9512 2.11816Z" fill="white"/>
    </svg>
)

const SpeakerOffIcon = (props: any) => (
    <svg width="25" height="18" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.4098 17.4204C11.9821 17.4204 12.3603 17.0033 12.3603 16.4407V1.01845C12.3603 0.455878 11.9821 0 11.4001 0C10.9927 0 10.7017 0.184291 10.304 0.562573L5.92955 4.76247C5.85195 4.84007 5.75496 4.87886 5.62886 4.87886H2.65111C1.46777 4.87886 0.75 5.59663 0.75 6.83817V10.6501C0.75 11.8819 1.46777 12.6094 2.65111 12.6094H5.62886C5.75496 12.6094 5.85195 12.6385 5.92955 12.7161L10.304 16.8966C10.6726 17.2361 11.0024 17.4204 11.4098 17.4204Z" fill="white"/>
        <path d="M23.0777 4.17574C23.312 3.94142 23.692 3.94142 23.9263 4.17574C24.1602 4.40998 24.1602 4.78917 23.9263 5.02339L20.3491 8.59956L23.9253 12.1757C24.1596 12.4101 24.1606 12.7901 23.9263 13.0244C23.692 13.2585 23.3119 13.2576 23.0777 13.0234L19.5015 9.44722L15.9263 13.0234C15.6921 13.2576 15.312 13.2584 15.0777 13.0244C14.8435 12.7902 14.8437 12.4101 15.0777 12.1757L18.6538 8.59956L15.0777 5.02339C14.8436 4.78913 14.8436 4.41001 15.0777 4.17574C15.312 3.94142 15.692 3.94142 15.9263 4.17574L19.5015 7.75093L23.0777 4.17574Z" fill="white"/>
    </svg>
)

const SpeakerIcon = (props: any) => (
    <svg width="28" height="19" viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.976 18.8938C24.2475 19.0877 24.6161 19.0101 24.8295 18.7095C26.5948 16.1682 27.6521 12.977 27.6521 9.50461C27.6521 6.03218 26.5948 2.83133 24.8295 0.299753C24.6161 -0.0106321 24.2475 -0.0882284 23.976 0.105762C23.6947 0.309452 23.6462 0.678035 23.8596 0.98842C25.4309 3.35511 26.459 6.28436 26.459 9.50461C26.459 12.7249 25.5182 15.7317 23.8499 18.0208C23.6365 18.3312 23.685 18.6901 23.976 18.8938ZM11.0077 18.1566C11.58 18.1566 11.9582 17.7395 11.9582 17.1769V1.75468C11.9582 1.19211 11.58 0.736232 10.998 0.736232C10.5906 0.736232 10.2996 0.920523 9.90194 1.2988L5.52745 5.4987C5.44985 5.5763 5.35286 5.6151 5.22676 5.6151H2.24901C1.06567 5.6151 0.3479 6.33286 0.3479 7.5744V11.3863C0.3479 12.6182 1.06567 13.3456 2.24901 13.3456H5.22676C5.35286 13.3456 5.44985 13.3747 5.52745 13.4523L9.90194 17.6328C10.2705 17.9723 10.6003 18.1566 11.0077 18.1566ZM20.1058 16.2652C20.3968 16.4592 20.746 16.3816 20.9594 16.0906C22.2591 14.3253 22.9866 11.9974 22.9866 9.50461C22.9866 7.00213 22.2688 4.67424 20.9594 2.90893C20.7363 2.61794 20.3968 2.54034 20.1058 2.74403C19.8149 2.93803 19.7761 3.29691 19.9991 3.61699C21.0758 5.23681 21.7936 7.26402 21.7936 9.50461C21.7936 11.7452 21.134 13.8306 19.9895 15.3922C19.7761 15.7026 19.8149 16.0712 20.1058 16.2652ZM16.2648 13.6657C16.5267 13.8403 16.8856 13.7918 17.099 13.5008C17.8556 12.5018 18.3308 11.0371 18.3308 9.50461C18.3308 7.96238 17.8556 6.50745 17.099 5.5084C16.8856 5.21742 16.5364 5.15922 16.2648 5.34351C15.9544 5.5569 15.9059 5.93518 16.1484 6.25527C16.7401 7.06033 17.1378 8.25337 17.1378 9.50461C17.1378 10.7655 16.7304 11.9586 16.129 12.7734C15.9059 13.0837 15.9544 13.4426 16.2648 13.6657Z" fill="white"/>
    </svg>
)